export const IMAGES = {
  // VALEUR
  LEGALITE: require("../assets/images/doc.svg"),
  DROIT: require("../assets/images/droit.svg"),
  PROFESSIONALISME: require("../assets/images/pro.svg"),
};
